import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "@common/axios";
import {UserContext} from "@context/UserContext";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import Button from "@common/Button";
import ListItemClass from "@common/ListItemClass";
import ButtonsGroup from "@common/ButtonsGroup";
import ButtonSelect from "@common/ButtonSelect";
import GoToButtonSection from "../components/GoToButtonSection";

const TeacherClassesDashboardWidget = props => {
    const {...other} = props;
    const {user, loadUser} = useContext(UserContext);
    const [classes, setClasses] = useState([]);
    const [url, setUrl] = useState();
    const [classList, setClassList] = useState([
        {value: '/web/ui/sc/schoolClasses', label: 'School classes'},
        {value: '/web/ui/sc/teacherClasses', label: 'My classes'}
    ]);
    const [isLoading, setLoading] = useState(true);
    const {loadShortcutByUrl} = useCurrentShortcut();

    useEffect(() => {
        setLoading(true);
        if (url !== undefined) {
            axios.get(url)
                .then(response => {
                    setClasses(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [user.classes, url]);

    const handleClassChange = selectedOption => {
        if (selectedOption.value !== undefined) setUrl(selectedOption.value);
    }

    const createClassFromDashboard = () => {
        if(user.schoolAdmin) {
            globalReactFunctions.createClassFromDashboard = true;
            loadShortcutByUrl('/web/ui/view/myClasses');
        } else {
            displayToastMessage('You need administrator access for this function', '', 'error');
        }
    }

    const clazzCallback = (classId) => {
        let userClassIds = user.classes.map(clazz => clazz.classId);

        if (userClassIds.includes(classId)){
            userClassIds = userClassIds.filter(id => id != classId)
        } else {
            userClassIds.push(classId);
        }

        axios.post('/web/ui/sc/updateTeacherClasses', userClassIds, {}).then(response => {
            loadUser();
        });
    }

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#classes-icon"></use>
                    </svg>
                    <span>Classes</span>
                </div>
            }
            isLoading={isLoading}
            headerActions={
                <ButtonsGroup>
                    <Button onClick={createClassFromDashboard} disabled={user.schoolId == null || user.limitedProduct}>Create class</Button>
                    <ButtonSelect type="outline" title="Classes" options={classList} value={classList[0]} onChange={handleClassChange} />
                </ButtonsGroup>
            }
            {...other}>
            <div className={'ch-dashboard-blk-body'}>
                {classes && classes.length > 0 &&
                    <table className={'ch-dashboard-widget-table ch-table'}>
                        <thead>
                            <tr>
                                <th>Class name</th>
                                <th>Class code</th>
                                <th className={'ch-align-center'}>Students</th>
                                <th className={'ch-align-center'}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {classes.map((clazz, index) => {
                                const inClass = user.classes.some(userClazz => userClazz.classId === clazz.classId);
                                return <ListItemClass key={clazz.classId} clazz={clazz} inClass={inClass} onClick={function () {clazzCallback(clazz.classId)}}/>
                            })}
                        </tbody>
                    </table>
                }
                {classes && classes.length == 0 &&
                    <div className="ch-list-item-disabled">No classes available</div>
                }
            </div>
            <GoToButtonSection buttonText={'Go to all my classes'}
                               onClick={() => loadShortcutByUrl('/web/ui/view/myClasses')}
                               disabled={user.schoolId == null || user.limitedProduct}/>
        </DashboardWidget>
    )
}

export default TeacherClassesDashboardWidget;